import { Dialog, DialogContent, DialogTitle, DialogDescription } from "@/components/ui/dialog";
import { Button } from "@/components/ui/button";
import { ShieldCheck, Printer, BadgeCheck } from "lucide-react";

export default function CertificateModal({ cert, onClose }) {
  if (!cert) return null;
  const certId = `BN-${(cert.title || "").split(" ").map((w) => w[0]).join("").toUpperCase().slice(0, 4)}-${(cert.date || "").replaceAll("-", "")}`;

  return (
    <Dialog open onOpenChange={(v) => !v && onClose()}>
      <DialogContent data-testid="certificate-modal" className="max-w-2xl rounded-2xl p-0 overflow-hidden gap-0">
        <DialogTitle className="sr-only">Sertifikat Digital Relawan</DialogTitle>
        <DialogDescription className="sr-only">Sertifikat apresiasi kontribusi relawan yang dapat dicetak atau diunduh sebagai PDF.</DialogDescription>
        <div className="certificate-print bg-white p-10 sm:p-12 text-center relative">
          <div className="absolute inset-3 border-2 border-emerald-600 rounded-xl pointer-events-none" aria-hidden="true" />
          <div className="absolute inset-5 border border-emerald-200 rounded-lg pointer-events-none" aria-hidden="true" />
          <div className="relative space-y-4">
            <span className="inline-flex bg-emerald-600 text-white rounded-full p-4">
              <ShieldCheck className="w-8 h-8" aria-hidden="true" />
            </span>
            <p className="text-xs font-black tracking-[0.35em] text-emerald-700 uppercase">Sertifikat Apresiasi Relawan</p>
            <p className="text-sm text-slate-500">Diberikan dengan hormat kepada</p>
            <h2 data-testid="certificate-name" className="font-heading font-black text-3xl sm:text-4xl text-slate-900 tracking-tight">{cert.name}</h2>
            <p className="text-sm text-slate-500">atas kontribusi nyata sebagai relawan dalam</p>
            <p data-testid="certificate-event" className="font-heading font-extrabold text-xl text-slate-900">{cert.title}</p>
            <div className="flex justify-center gap-10 pt-2">
              <div>
                <p className="font-heading font-black text-2xl text-emerald-700">{cert.hours} Jam</p>
                <p className="text-[10px] font-bold text-slate-400 uppercase tracking-wider">Kontribusi Terverifikasi</p>
              </div>
              <div>
                <p className="font-heading font-black text-2xl text-slate-900">{cert.date}</p>
                <p className="text-[10px] font-bold text-slate-400 uppercase tracking-wider">Tanggal Aksi</p>
              </div>
            </div>
            <div className="flex items-center justify-center gap-1.5 text-xs text-slate-400 pt-4 mt-2 border-t border-slate-100">
              <BadgeCheck className="w-4 h-4 text-emerald-600" aria-hidden="true" />
              Diverifikasi oleh BergerakNyata — Civic Impact Platform · No. {certId}
            </div>
          </div>
        </div>
        <div className="bg-slate-50 border-t border-slate-200 p-4 flex justify-end gap-2">
          <Button data-testid="cert-close-btn" variant="outline" onClick={onClose} className="rounded-full font-bold">Tutup</Button>
          <Button data-testid="cert-print-btn" onClick={() => window.print()}
            className="rounded-full bg-emerald-600 hover:bg-emerald-700 text-white font-bold">
            <Printer className="w-4 h-4 mr-2" /> Cetak / Unduh PDF
          </Button>
        </div>
      </DialogContent>
    </Dialog>
  );
}
